export function item(state, data) {
  state.item = data
}

export function items(state, data) {
  state.items = data
}

export function pagination(state, data) {
  state.pagination = data
}

export function widthMeasures(state, data) {
  state.widthMeasures = data
}

export function heightMeasures(state, data) {
  state.heightMeasures = data
}

export function rimMeasures(state, data) {
  state.rimMeasures = data
}

export function brands(state, data) {
  state.brands = data
}

export function models(state, data) {
  state.models = data
}

export function years(state, data) {
  state.years = data
}

export function version(state, data) {
  state.version = data
}

export function vehicle(state, data) {
  state.vehicle = data
}
